"use client";
import {
  clearDatadogUser,
  setDatadogUser,
} from "@/modules/lib/observability/datadogUtils";
import type { ISession } from "@/modules/session";
import { createContext, useContext, useEffect } from "react";

export interface ISessionContext extends ISession {
  loggedIn: boolean;
}

const SessionContext = createContext<ISessionContext>({
  user: undefined,
  logout: async () => {},
  loggedIn: false,
});

export const SessionProvider: React.FC<{
  children: React.ReactNode;
  session: ISession;
}> = ({ children, session }) => {
  const { user } = session;

  useEffect(() => {
    if (!user) {
      clearDatadogUser();
      return;
    }

    setDatadogUser({
      id: user.id,
    });
  }, [user]);

  return (
    <SessionContext.Provider
      value={{ ...session, loggedIn: !!session?.user?.id }}
    >
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => {
  return useContext(SessionContext);
};
